import React from "react";
//
import { FlexDiv } from "@/components/Atoms/Box";
import Image from "@/components/Atoms/Image";
//
import { Typography } from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";
//
import {
  Container,
  ImageBox,
  ItemBox,
  LHSSection,
  List,
  RHSSection,
  Wrapper,
} from "./style";
//
function KeysWebinar({ isMobile, data = {} }) {
  return (
    data?.how_it_works?.listing?.length > 0 && (
      <Wrapper>
        <Container>
          <LHSSection flexDirection={"column"}>
            <Typography
              variant={"display4"}
              mb={isMobile ? "16px" : "24px"}
              color={theme.colorsV2.purple.shade_800}
            >
              {data?.how_it_works?.title}
            </Typography>
            <Typography
              variant={"paragraph2"}
              color={theme.colorsV2.gray.shade_600}
              mb={"24px"}
            >
              {data?.how_it_works?.subtitle}
            </Typography>
            {data?.features?.length > 0 && (
              <FlexDiv flexWrap={"wrap"}>
                {data?.features?.map((item, index) => {
                  return (
                    <ItemBox key={index}>
                      <ImageBox mb={"8px"}>
                        {item.image && <Image src={item.image} />}
                      </ImageBox>
                      <Typography
                        variant="label1"
                        color={theme.colorsV2.primary.shade_800}
                      >
                        {item.title}
                      </Typography>
                    </ItemBox>
                  );
                })}
              </FlexDiv>
            )}
          </LHSSection>
          <RHSSection>
            {data?.how_it_works?.listing?.map((item, index) => {
              return (
                <List
                  key={index}
                  variant="label2"
                  color={theme.colorsV2.purple.shade_900}
                >
                  {item.title}
                </List>
              );
            })}
          </RHSSection>
        </Container>
      </Wrapper>
    )
  );
}

export default KeysWebinar;
